// test1021
(1021 && 0);
